import { Component, OnChanges, Input, SimpleChanges, OnInit } from '@angular/core';
import { IDashBoardAdminChartDetails } from "../dasboard-admin-chart-details.model";
import { ChartValue } from "../chart/chart-value.model";
import { PieChartOptions } from "../chart/pie-chart-options.model";
import { IPublisher } from "../../shared/publisher.model";
import { TopFillBySourceService } from "./top-fill-by-source.service";

@Component({
    moduleId: module.id,
    selector: 'top-fill-by-source',
    templateUrl: 'top-fill-by-source.component.html'
})
export class TopFillBySourceComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetails;
    @Input() showBottomSectionOverlay: boolean;
    private readonly stepValue: number = 6;
    chartValues: ChartValue[];
    chartOptions: PieChartOptions = new PieChartOptions();
    groupedChartValues: any[];

    constructor(private topFillBySourceService: TopFillBySourceService) {
    }

    ngOnInit() {
        this.chartOptions.needRemainingPercentage = true;
        this.chartOptions.legendSelector = ".custom_legend";
    }

    private mapAllData(): void {
        let publishers: IPublisher[] = new Array<IPublisher>();
        this.chartValues = new Array<ChartValue>();
        this.groupedChartValues = new Array<any>();
        for (let item of this.data.fillBySource) {
            if (publishers.findIndex(s => s.id == item.publisher.id) == -1)
                publishers.push(item.publisher);
        }
        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let fillBySources = this.data.fillBySource.filter(x => x.publisher.id == publisher.id);
                let sum = 0;
                fillBySources.forEach(s => sum += s.fillPercentage);
                let avg = sum / fillBySources.length;
                let chartValue = new ChartValue(publisher.name, [avg], publisher.id);
                this.chartValues.push(chartValue);
            }
        }
        let orderedChartValues = this.chartValues.sort((a: ChartValue, b: ChartValue) => {
            if (a.data[0] > b.data[0])
                return -1;
            else if (a.data[0] < b.data[0])
                return 1;
            else
                return 0;
        });
        this.groupedChartValues = this.topFillBySourceService.generateGroupedArray(orderedChartValues, this.stepValue);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue) {
            this.mapAllData();
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/dashboard/topfillbysource/top-fill-by-source.component.ts